module.exports = __webpack_public_path__ + "static/media/map-9.67112315.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-9.png
// module id = 591
// module chunks = 23